import { AxiosInstance } from 'axios'

import {
  iamDefaultApiFactory,
  userApiDefaultApiFactory,
} from '@src/api/default-api-factories'
import {
  DefaultApiCheckAlreadyRegisteredPhoneNumberRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/iam'
import { DefaultApiTwoFactorAuthResetAsTokenRequest } from '@src/api/generated/user-api'

export const checkAlreadyRegisteredPhoneNumber = async (
  instance: AxiosInstance,
  params: DefaultApiCheckAlreadyRegisteredPhoneNumberRequest
) => {
  return await iamDefaultApiFactory(instance).checkAlreadyRegisteredPhoneNumber(
    params
  )
}

export const deactivateTfa = async (axiosInstance: AxiosInstance) => {
  return iamDefaultApiFactory(axiosInstance).twoFactorAuthReset()
}

export const deactivateTfaAsToken = async (
  instance: AxiosInstance,
  params: DefaultApiTwoFactorAuthResetAsTokenRequest
) => {
  return await userApiDefaultApiFactory(instance).twoFactorAuthResetAsToken(
    params
  )
}

export const getTfaAppQRCode = async (instance: AxiosInstance) => {
  return await iamDefaultApiFactory(instance).getTfaAppQrCode()
}

export const getTfaAppRecoveryCode = async (instance: AxiosInstance) => {
  return iamDefaultApiFactory(instance).getTfaAppRecoveryCode()
}

export const getTfaSmsRecoveryCode = async (instance: AxiosInstance) => {
  return iamDefaultApiFactory(instance).getTfaSmsRecoveryCode()
}

export const registerTfaAppVerificationCode = async (
  instance: AxiosInstance,
  { verificationCode }: { verificationCode: string }
) => {
  return await iamDefaultApiFactory(instance).registerTfaAppVerificationCode({
    registerAppAuthForm: { verificationCode },
  })
}

export const registerTfaSmsAuth = async (
  instance: AxiosInstance,
  { idToken }: { idToken: string }
) => {
  const registerSmsAuthForm = { idToken }
  return await iamDefaultApiFactory(instance).registerTfaSmsAuth({
    registerSmsAuthForm,
  })
}

// Do Not Remove this line ===@import api client===
